export type VolumeIcon = 'method' | 'rhythm' | 'harmony' | 'language' | 'improv' | 'jam'
export interface Volume {
  number: string
  title: string
  /** Short name printed on the mini cover in the hero. */
  shortTitle: string
  description: string
  contents: string[]
  icon: VolumeIcon
  /** Accent color for the volume's icon tile. */
  accent: string
}
export const volumes: Volume[] = [
  {
    number: '01',
    title: 'Metoda nauczania jazzu',
    shortTitle: 'Metoda',
    description:
      'Fundament całego systemu: jak zaplanować rok, ułożyć lekcję i przeprowadzić ucznia z poziomu na poziom.',
    contents: ['Struktura lekcji', 'Plan roczny', 'Kryteria poziomów', 'Ocenianie'],
    icon: 'method',
    accent: '#2E5B4A',
  },
  {
    number: '02',
    title: 'Mistrzostwo swingu i compingu',
    shortTitle: 'Swing',
    description:
      '50 kompletnych sesji o swingowym feelingu, wzorcach compingu i architekturze rytmu — wszystko w uporządkowanej progresji.',
    contents: ['Swing feel', 'Wzorce compingu', 'Groove', 'Ćwiczenia rytmiczne'],
    icon: 'rhythm',
    accent: '#1F3A5F',
  },
  {
    number: '03',
    title: 'Mistrzostwo akordów i progresji',
    shortTitle: 'Akordy',
    description:
      'Teoria akordów, ii-V-I we wszystkich tonacjach, prowadzenie głosów i substytucje — lekcja po lekcji.',
    contents: ['Akordy septymowe', 'ii-V-I we wszystkich tonacjach', 'Substytucja trytonowa', 'Prowadzenie głosów'],
    icon: 'harmony',
    accent: '#8A6420',
  },
  {
    number: '04',
    title: 'Język i frazowanie jazzowe',
    shortTitle: 'Język',
    description:
      'Licki, artykulacja i frazowanie rozpisane tak, by uczniowie przestali grać gamy i zaczęli mówić językiem jazzu.',
    contents: ['Artykulacja', 'Słownictwo', 'Budowanie fraz', 'Transkrypcja'],
    icon: 'language',
    accent: '#4A3524',
  },
  {
    number: '05',
    title: 'Improwizacja i solówki',
    shortTitle: 'Solo',
    description:
      'Ścieżka krok po kroku od dźwięków prowadzących do pełnych chorusów, z ćwiczeniami i standardami na każdy etap.',
    contents: ['Dźwięki prowadzące', 'Skale modalne i arpeggia', 'Budowanie solówki', 'Standardy'],
    icon: 'improv',
    accent: '#8E3232',
  },
  {
    number: '06',
    title: 'Mistrzostwo jam session',
    shortTitle: 'Jam',
    description:
      'Wszystko, czego uczniowie potrzebują do gry z innymi: odliczanie, wymiana chorusów, savoir-vivre i rutyny zespołowe.',
    contents: ['Gra zespołowa', 'Wymiana chorusów', 'Savoir-vivre', 'Rutyny grupowe'],
    icon: 'jam',
    accent: '#2B4A4E',
  },
]
